// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eTLu","name":"styles_name__ImrU8","phone":"styles_phone__n5Q0O"};